import React, { useState, useEffect } from 'react';
import './Subtractions.css';

const allQuestions = [
  { question: '5-3=?', options: ['1', '2', '4', '3'], answer: '2' },
  { question: '4-1=?', options: ['3', '4', '5', '6'], answer: '3' },
  { question: '3-2=?', options: ['2','3','1','0'], answer: '1' },
  { question: '7-4=?', options: ['1', '2', '3', '4'], answer: '3' },
  { question: '9-6=?', options: ['1', '2', '3', '4'], answer: '3' },
  { question: '8-2=?', options: ['4', '5', '6', '7'], answer: '6' },
  { question: '6-1=?', options: ['4', '5', '6', '7'], answer: '5' },
  { question: '10-7=?', options: ['1', '2', '3', '4'], answer: '3' },
  { question: '2-1=?', options: ['1', '2', '3', '4'], answer: '1' },
  { question: '6-3=?', options: ['3', '4', '5', '6'], answer: '3' },
  { question: '10-3=?', options: ['6', '8', '5', '7'], answer: '7' },
  { question: '8-5=?', options: ['3', '4', '5', '6'], answer: '3' },

  { question: '3-3=?', options: ['1', '2', '0', '3'], answer: '0' },
  { question: '4-2=?', options: ['3', '4', '1', '2'], answer: '2' },
  { question: '9-2=?', options: ['6', '7', '8', '9'], answer: '7' },
  { question: '7-0=?', options: ['1', '0', '7', '2'], answer: '7' },
  { question: '9-1=?', options: ['1', '2', '8', '6'], answer: '8' },
  { question: '8-4=?', options: ['4', '5', '6', '7'], answer: '4' },
  { question: '6-5=?', options: ['4', '5', '6', '1'], answer: '1' },
  { question: '10-10=?', options: ['1', '2', '3', '0'], answer: '0' },
  { question: '8-1=?', options: ['1', '8', '7', '4'], answer: '7' },
  { question: '7-5=?', options: ['3', '2', '5', '6'], answer: '2' },

  { question: '13-3=?', options: ['11', '12', '10', '13'], answer: '10' },
  { question: '14-2=?', options: ['13', '14', '11', '12'], answer: '12' },
  { question: '19-2=?', options: ['16', '17', '18', '19'], answer: '17' },
  { question: '17-0=?', options: ['11', '10', '17', '12'], answer: '17' },
  { question: '19-1=?', options: ['11', '12', '18', '16'], answer: '18' },
  { question: '18-4=?', options: ['14', '15', '16', '17'], answer: '14' },
  { question: '16-5=?', options: ['14', '15', '16', '11'], answer: '11' },
  { question: '20-10=?', options: ['10', '20', '30', '0'], answer: '10' },
  { question: '19-1=?', options: ['11', '18', '17', '14'], answer: '18' },
  { question: '16-5=?', options: ['13', '11', '15', '16'], answer: '11' },

  { question: '33-13=?', options: ['31', '20', '10', '30'], answer: '20' },
  { question: '24-12=?', options: ['13', '24', '12', '22'], answer: '12' },
  { question: '99-12=?', options: ['67', '77', '87', '89'], answer: '87' },
  { question: '37-10=?', options: ['21', '20', '27', '22'], answer: '27' },
  { question: '39-11=?', options: ['21', '27', '28', '26'], answer: '28' },
  { question: '78-74=?', options: ['4', '5', '6', '7'], answer: '4' },
  { question: '66-55=?', options: ['14', '15', '16', '11'], answer: '11' },
  { question: '100-20=?', options: ['90', '20', '70', '80'], answer: '80' },
  { question: '99-91=?', options: ['1', '8', '7', '4'], answer: '8' },
  { question: '66-65=?', options: ['3', '1', '5', '6'], answer: '1' },
];

const getRandomQuestions = (num) => {
  const shuffled = [...allQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, num);
};

const Subtractions = () => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState('');
  const [isAnswered, setIsAnswered] = useState(false);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);

  useEffect(() => {
    setQuestions(getRandomQuestions(10));
  }, []);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsAnswered(true);
    if (selectedOption === questions[currentQuestion].answer) {
      setScore(score + 1);
    }
  };

  const handleNextQuestion = () => {
    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
      setIsAnswered(false);
      setSelectedOption('');
    } else {
      setShowScore(true);
    }
  };
  const openUrl = () => {
    window.open('https://draftj.in', '_blank');
}
const clearBoard = () => {
    // setBoard([...originalBoard]);
    window.location.reload();
   };
   const playSound = () => {
    const audio = new Audio('/Applauds.mp3');
    audio.play();
  };
  return (
    <div className="Apps">
      <h1>Subtractions Quiz &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button onClick={openUrl}>Home</button> &nbsp;&nbsp;&nbsp;&nbsp;<button onClick={clearBoard}>Start Quiz Again</button></h1>
      {showScore ? (
        <div className="score-section">
          Your score: {score} out of {questions.length}
        </div>
      ) : (
        questions.length > 0 && (
          <div className="question-section">
            <div className="question-text">
              {questions[currentQuestion].question}
            </div>
<form onSubmit={handleSubmit}>
  {questions[currentQuestion].options.map((option, index) => {
    const optionLetter = String.fromCharCode(97 + index); // 'a' is char code 97
    return (
      <div key={index} className="option-item">
        <label htmlFor={`option-${index}`}>
          <strong>{optionLetter})</strong>&nbsp;
          <input
            type="radio"
            id={`option-${index}`}
            name="option"
            value={option}
            checked={selectedOption === option}
            onChange={handleOptionChange}
            disabled={isAnswered}
          />
          {option}
        </label>
      </div>
    );
  })}
  {!isAnswered && <button type="submit">Submit</button>}
</form>


            {isAnswered && (
              <div className="answer-section">
                {selectedOption === questions[currentQuestion].answer ? (
                    
                  <p>Correct! </p>

                  
                ) : (
                  <p>Wrong! The correct answer is {questions[currentQuestion].answer}.</p>
                )}
                <button onClick={handleNextQuestion}>Next Question</button>
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default Subtractions;
